import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    // Initialisiere das Feld mit dem visuellen https:// Präfix
    this.updateDisplay()
  }

  updateDisplay() {
    const input = this.inputTarget
    let url = input.value.trim()
    
    // Entferne https:// vom Anfang falls vorhanden (da es visuell angezeigt wird)
    if (url.startsWith('https://')) {
      url = url.substring(8)
    }
    
    // Entferne führende/schließende Slashes
    url = url.replace(/^\/+|\/+$/g, '')
    
    // Aktualisiere den Wert ohne https:// (da es visuell angezeigt wird)
    input.value = url
  }

  normalizeUrl() {
    const input = this.inputTarget
    let url = input.value.trim()
    
    // Entferne führende/schließende Slashes
    url = url.replace(/^\/+|\/+$/g, '')
    
    if (url) {
      // Setze den vollständigen Wert mit https:// für das Backend
      input.value = `https://${url}`
    }
  }
}
